import React from "react";
import "react-datetime/css/react-datetime.css";

function TimeInput({
  name,
  id,
  label,
  value = "",
  handleChange,
  required,
  disabled,
  errorMessage,
  maxLength,
  cName,
  placeholder
}) {
  return (
    <>
      {label && (
       <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div>
        <input
          type="time"
          className={`form-control ${cName} ${errorMessage?.[name]?.trim()?.length > 0 ? "input-error" : ""}`}
          name={name}
          id={id}
          value={value || ""}
          onChange={handleChange}
          required={required}
          disabled={disabled}
          placeholder={placeholder || ""}
          maxLength={maxLength}
        />
          <i className="bi bi-clock-fill position-absolute" style={{ right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: "#6c757d" }}></i>
      </div>
      {errorMessage && errorMessage[name] && Object?.keys(errorMessage).length > 0 && (
        <div className="text-danger fw-700 fs-6">
          {errorMessage && errorMessage[name] && errorMessage[name]}
        </div>
      )}
    </>
  );
}

export default TimeInput;
